import React from 'react';
import './Footer.css'; // Assurez-vous d'avoir un fichier CSS pour le style


const Footer = () => {
    return (
        <footer className="footer">
            <div className="container section">
                <div className="footer-row">
                    <div className="footer-contact">
                        <img src="/logo_light.webp" alt="AstraLight Logo" className="footer-logo" />
                        <p>Contact: <a href="mailto:contact@astralight.xyz">contact@astralight.xyz</a></p>
                        <p className="footer-attribution">
                            <a href="https://www.flaticon.com/packs/esoteric-11" title="esoteric icons">
                                Esoteric icons created by Freepik - Flaticon
                            </a>
                        </p>
                    </div>
                </div>
                <hr />
                <div className="footer-bottom">
                    <p>Copyright © {new Date().getFullYear()} AstraLight</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer; 